module.exports = __webpack_public_path__ + "img/c.572fd667.png";